import { adminApi, SERVER_ERROR_MESSAGE, toAdminErrorMessage } from '../auth/adminApi';

// 문의 목록을 조회한다. status가 'all'이면 전체. GET /admin/api/inquiry/list?status=pending|answered
export async function getInquiries(status) {
    let data;
    try {
        ({ data } = await adminApi.get('/admin/api/inquiry/list', { params: status === 'all' ? {} : { status } }));
    } catch (error) {
        throw new Error(toAdminErrorMessage(error));
    }
    if (!Array.isArray(data)) throw new Error(SERVER_ERROR_MESSAGE);
    return data;
}

// 문의 상세를 조회한다. GET /admin/api/inquiry/:id
export async function getInquiry(id) {
    try {
        const { data } = await adminApi.get(`/admin/api/inquiry/${encodeURIComponent(id)}`);
        return data;
    } catch (error) {
        throw new Error(toAdminErrorMessage(error, '문의를 찾을 수 없습니다.'));
    }
}

// 문의에 답변을 등록한다. POST /admin/api/inquiry/:id/answer { answer }
export async function answerInquiry(id, answer) {
    try {
        await adminApi.post(`/admin/api/inquiry/${encodeURIComponent(id)}/answer`, { answer });
    } catch (error) {
        throw new Error(toAdminErrorMessage(error, '문의를 찾을 수 없습니다.'));
    }
}
